import { useState, useEffect, useCallback } from 'react'
import { getAllGists, saveGists, getMetadata, setMetadata, clearAllData } from '../utils/db'

export function useIndexedDB() {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  const loadFromStorage = useCallback(async () => {
    try {
      const gists = await getAllGists()
      const lastSynced = await getMetadata('lastSynced')
      setData({ lastSynced, gists })
    } catch (error) {
      console.error('Failed to load from IndexedDB:', error)
      setData({ lastSynced: null, gists: [] })
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    loadFromStorage()
  }, [loadFromStorage])

  const saveToStorage = useCallback(async (gists) => {
    try {
      const lastSynced = new Date().toISOString()
      await saveGists(gists)
      await setMetadata('lastSynced', lastSynced)
      setData({ lastSynced, gists })
      return true
    } catch (error) {
      console.error('Failed to save to IndexedDB:', error)
      return false
    }
  }, [])

  const clearStorage = useCallback(async () => {
    try {
      await clearAllData()
      setData({ lastSynced: null, gists: [] })
    } catch (error) {
      console.error('Failed to clear IndexedDB:', error)
    }
  }, [])

  return {
    data,
    isLoading,
    saveToStorage,
    clearStorage,
    loadFromStorage,
  }
}
